import { CircleCheck } from "lucide-react";
import React from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";

import { useGetOrg } from "../../../../api/organizations/get-organization";

interface RechargeIntegrationProps {
  rechargeIntegration?: BaseIntegrationDto;
}

export const RechargeIntegration = ({
  rechargeIntegration,
}: RechargeIntegrationProps) => {
  const organization = useGetOrg();
  const theme = useTheme();
  const onEnableClick = () => {
    if (organization.data.org.shopId) {
      let client_id: string;
      if (import.meta.env.VITE_STAGE === "local") {
        client_id =
          "d8bafb5d6aab01c6a36e0f5b388d3f9db48df616aa39d14521f1037d7dc2def8";
      } else if (import.meta.env.VITE_STAGE === "dev") {
        client_id =
          "83878c4b6109b555ac8669f2bc8a05f7b92ac4094f081bd05dbf7363bc1f9af7";
      } else {
        client_id =
          "cc9bfffa79b0b670267995ea6a21354a56fb2aaa147877deebb65ddf9d59fb41";
      }

      window.location.href = `https://admin.rechargeapps.com/partners/app/${client_id}/install?myshopify_domain=${
        organization.data.org.shopId.split(".")[0]
      }`;
    }
  };

  return (
    <IgPaper sx={{ boxShadow: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container item alignItems={"center"} columnSpacing={2}>
            {rechargeIntegration?.enabled ? (
              <Grid item>
                <CircleCheck size={24} color={theme.igIconColors.success} />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                variant={"h3"}
                sx={{
                  fontWeight: 600,
                }}
              >
                Recharge
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgButton variant={"contained"} onClick={onEnableClick}>
            {rechargeIntegration?.enabled ? "Refresh" : "Enable"}
          </IgButton>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
